/**
 * Mirrors the resolved theme mode onto <html data-theme> and the root
 * `color-scheme`, which is what tokens.css responds to. The shared
 * ThemeProvider owns the state and persistence; this is only the DOM bridge,
 * and it is the same arrangement the member web app uses.
 */
import { useEffect } from 'react';
import { useTheme } from '@wlb/shared/theme';

export function ThemeApplier(): null {
  const { mode, preferenceLoaded } = useTheme();

  useEffect(() => {
    // The inline script in index.html already applied the stored preference
    // before first paint. Until storage resolves, `mode` is only the OS
    // default, so writing it here would cause the flash that script prevents.
    if (!preferenceLoaded) {
      return;
    }
    const root = document.documentElement;
    root.setAttribute('data-theme', mode);
    root.style.colorScheme = mode;
  }, [mode, preferenceLoaded]);

  return null;
}
